import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Checkbox,
  Typography,
} from '@mui/material';

const FloorPlanSelectionModal = (props: any) => {
  const {
    isFloorPlanModalOpen,
    setIsFloorPlanModalOpen,
    onUploadFiles,
    preUploadedFiles,
    setPreUploadedFiles,
  } = props;

  const handleFloorPlanSelection = (event: any) => {
    const tempFiles = [].concat(preUploadedFiles);
    setPreUploadedFiles(
      tempFiles.map((item: any) => {
        if (item.id.toString() === event.target.name) {
          return { ...item, isFlorPlan: event.target.checked };
        }
        return item;
      }),
    );
  };

  if (preUploadedFiles.length === 0) {
    return <></>;
  }

  return (
    <>
      <Dialog
        maxWidth={'md'}
        fullWidth={false}
        open={isFloorPlanModalOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-content"
      >
        <DialogTitle id="alert-dialog-title" className="bmls_dialog_title">
          Uploading Floor Plans
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-content"
            className="bmls_dialog_content"
          >
            Select which document(s) are floor plans.
          </DialogContentText>
          <Box sx={{ pt: 1 }}>
            <Box
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Typography sx={{ fontWeight: 'bold', width: '400px' }}>
                Document Name
              </Typography>
              <Typography sx={{ fontWeight: 'bold' }}>
                Is this a Floor Plan?
              </Typography>
            </Box>
            <Divider orientation="horizontal" aria-hidden="true" />
            {preUploadedFiles.map((obj: any) => {
              return (
                <Box key={`floor-plan-${obj.id}`}>
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography noWrap={true} sx={{ width: '400px' }}>
                      {obj.file.name}
                    </Typography>
                    <Box sx={{ mx: 3 }}>
                      <Checkbox
                        className="bmls_checkbox"
                        size="medium"
                        name={obj.id.toString()}
                        onChange={handleFloorPlanSelection}
                      />
                    </Box>
                  </Box>
                  <Divider orientation="horizontal" aria-hidden="true" />
                </Box>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'start', ml: 2 }}>
          <Button
            variant="contained"
            className="bmls_btn"
            onClick={onUploadFiles}
          >
            Continue
          </Button>
          <Button
            className="bmls_btn"
            onClick={() => setIsFloorPlanModalOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FloorPlanSelectionModal;
